import { CHUNK_COUNT, CHUNK_SIZE, MIN_Y, WORLD_SIZE } from "./constants.js";
import { buildMips, updateMipsAt } from "./heightMips.js";

export default class TerrainData {
    constructor() {
        this.heights = new Int16Array(WORLD_SIZE * WORLD_SIZE);
        this.baseHeights = new Int16Array(WORLD_SIZE * WORLD_SIZE);
        this.mips = buildMips(this.heights, WORLD_SIZE);
        this.layout = null;
    }

    index(i, j) {
        return j * WORLD_SIZE + i;
    }

    inBounds(i, j) {
        return i >= 0 && j >= 0 && i < WORLD_SIZE && j < WORLD_SIZE;
    }

    heightAt(i, j) {
        if (!this.inBounds(i, j)) return MIN_Y;
        return this.heights[this.index(i, j)];
    }

    baseHeightAt(i, j) {
        if (!this.inBounds(i, j)) return MIN_Y;
        return this.baseHeights[this.index(i, j)];
    }

    setColumn(i, j, height) {
        this.heights[this.index(i, j)] = height;
        updateMipsAt(this.mips, WORLD_SIZE, i, j);
    }

    replace(heights, baseHeights) {
        this.heights.set(heights);
        this.baseHeights.set(baseHeights);
        this.mips = buildMips(this.heights, WORLD_SIZE);
    }

    restoreBase() {
        const previous = new Int16Array(this.heights);
        this.heights.set(this.baseHeights);
        this.mips = buildMips(this.heights, WORLD_SIZE);
        return dirtyChunks(previous, this.heights);
    }
}

export function dirtyChunks(previous, next) {
    const dirty = [];
    for (let cz = 0; cz < CHUNK_COUNT; cz++) {
        for (let cx = 0; cx < CHUNK_COUNT; cx++) {
            const i0 = cx * CHUNK_SIZE;
            const j0 = cz * CHUNK_SIZE;
            let changed = false;
            for (let j = j0; j < j0 + CHUNK_SIZE && !changed; j++) {
                const row = j * WORLD_SIZE;
                for (let i = i0; i < i0 + CHUNK_SIZE; i++) {
                    if (previous[row + i] !== next[row + i]) {
                        changed = true;
                        break;
                    }
                }
            }
            if (changed) dirty.push([cx, cz]);
        }
    }
    return dirty;
}
